import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-damages',
  templateUrl: './handover-damages.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverDamagesComponent implements OnInit {

  @Input() model?: HandoverModel;

  constructor() {
  }

  ngOnInit(): void {
  }

}
